import { chalkRect, chalkText } from '../../primitives/chalk';

function createLocalAnimQueue() {
  return {
    fns: [],
    add(fn) {
      this.fns.push(fn);
    },
    tick(dt) {
      this.fns = this.fns.filter((fn) => fn(dt));
    },
    get active() {
      return this.fns.length > 0;
    },
  };
}

export async function prepareBoxedDemoNode(env, spec, registry) {
  const area = env.boardArea();
  const paddingK = spec.paddingK ?? 0.06;
  const inner = {
    x: area.x + area.w * paddingK,
    y: area.y + area.h * paddingK,
    w: area.w * (1 - paddingK * 2),
    h: area.h * (1 - paddingK * 2),
  };

  const title = spec.title ? String(spec.title) : '';
  const titleSize = env.getStyle('smallSize');

  const childFactory = registry.get(spec.child?.kind);
  if (!childFactory) {
    throw new Error(`BOXED_DEMO child factory not found: ${spec.child?.kind}`);
  }

  const childEnv = {
    ...env,
    boardArea: () => ({
      x: inner.x + 10,
      y: title ? inner.y + titleSize + 14 : inner.y + 8,
      w: inner.w - 20,
      h: title ? inner.h - (titleSize + 22) : inner.h - 16,
    }),
  };
  const childPacket = await childFactory.prepare(childEnv, spec.child.payload);

  return {
    area,
    inner,
    title,
    titleSize,
    childFactory,
    childPacket,
    childPayload: spec.child.payload,
  };
}

export function commitBoxedDemoNode(packet, ctxs, anim) {
  const localAnim = createLocalAnimQueue();
  packet.childFactory.commit(
    packet.childPacket,
    { ink: ctxs.ink, interaction: ctxs.interaction },
    localAnim,
    packet.childPayload
  );

  anim.add((dt) => {
    localAnim.tick(dt);

    chalkRect(ctxs.ink, packet.inner.x, packet.inner.y, packet.inner.w, packet.inner.h, 0.8);
    if (packet.title) {
      chalkText(
        ctxs.ink,
        packet.title,
        packet.inner.x + packet.inner.w / 2,
        packet.inner.y + packet.titleSize + 2,
        packet.titleSize,
        0.82,
        'ui-sans-serif, system-ui',
        'center'
      );
    }

    return localAnim.active;
  });
}
